import { gql } from '@apollo/client'

// reexported as a default export for GQL code gen
// because we are using custom useOperation hook wrappers
export default gql
